var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37034 18.8134L4.3779 18.711H17.8337C18.4098 18.711 18.9316 18.4167 19.2279 17.9238C19.3737 17.6839 19.4541 17.4096 19.4623 17.1291C19.4706 16.8541 19.4067 16.5797 19.2788 16.3357L19.2712 16.3226L12.4863 3.51381C12.19 3.04012 11.6709 2.75 11.1058 2.75C10.5015 2.75 9.95078 3.08137 9.66753 3.61487L2.94103 16.3226C2.80834 16.5708 2.74303 16.8492 2.75059 17.1291C2.75815 17.4089 2.83859 17.6839 2.98434 17.9231C3.12871 18.1651 3.33359 18.3652 3.57696 18.5027C3.81896 18.6388 4.09328 18.711 4.37034 18.711V18.8134ZM4.03621 17.2906L4.1964 16.9874L11.1058 3.93594L18.1795 17.2906H4.03621Z",
    fill: "#E41B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6406 7.74683L10.2656 7.74683L10.2656 12.5593L11.6406 12.5593L11.6406 7.74683Z",
    fill: "#E41B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.686 13.7053L10.2656 13.7053L10.2656 15.125L11.686 15.125L11.686 13.7053Z",
    fill: "#E41B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsErrorRed);
export default __webpack_public_path__ + "static/media/icons-error-red.7044da78d868de579ef3b7f88508266a.svg";
export { ForwardRef as ReactComponent };